<template>
  <div class="chart-container">
    <span class="chart-title">{{ props.chartTitle }}</span>
    <div class="stacked-bar-chart">
    <div class="grid-lines">
      <div
        v-for="(line, index) in gridLineCount"
        :key="index"
        class="grid-line"
        :class="{main: props.isMain}"
        :style="{ bottom: `${(index / (gridLineCount - 1)) * 100}%` }"
      ></div>
    </div>
    <div
      v-for="(bar, index) in data"
      :key="index"
      class="bar-container"
      :style="{ opacity: index % 2 !== 0 ? 1 : 0.7 }"
    >
      <div class="bar">
        <div
          class="stack primary-stack"
          :style="getStackStyle(bar.scripts, primaryColor)"
        ></div>
        <div
          v-if="bar.claims > 0"
          class="stack secondary-stack"
          :style="getStackStyle(bar.claims, 'lightgray')"
        ></div>
        
      </div>
      <div class="label" :class="{main: props.isMain}">
        {{ bar.month }}
      </div>
    </div>
  </div>
  </div>
  
</template>

<script setup lang="ts">
import { computed } from 'vue'

export interface BarData {
  claims: number
  scripts: number
  month: string
}

const props = defineProps<{
  data: BarData[]
  maxHeight: number
  primaryColor: string
  gridLineCount?: number
  isMain: boolean
  chartTitle?: string
}>()

const gridLineCount = computed(() => props.gridLineCount || 5)

const getStackStyle = (value: number, color: string) => {
  const height = (value / props.maxHeight) * 100
  return {
    height: `${height}%`,
    backgroundColor: color,
  }
}
</script>

<style scoped>
.chart-container{
  display: flex;
  /* gap: 0.625rem; */
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.chart-title{
  font-size: var(--font-size-small);
  opacity: 0.5;
  margin-bottom: 0.625rem;
}
.stacked-bar-chart {
  position: relative;
  display: flex;
  gap: 0.625rem;
  justify-content: space-around;
  align-items: flex-end;
  height: 12.5rem;
  width: 100%;
  max-width: 15.625rem;
  overflow: hidden;
}

.grid-lines {
  position: absolute;
  top: 1.25rem;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.1;
}

.grid-line {
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.0625rem;
  background: var(--color-text)
}

.grid-line.main {
  background: var(--color-background-bright)
}

.bar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
  z-index: 1;
}

.bar {
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  width: 1.25rem;
  overflow: hidden;
  gap: 0.3125rem;
}

.stack {
  width: 100%;
  border-radius: 15.625rem;
  min-height: 1.25rem;
}

.label {
  margin-top: 0.5rem;
  font-size: var(--font-size-caption);
  text-align: center;
  color: var(--color-text);
  opacity: 0.5;
}

.label.main {
  color: var(--color-background-bright);
}
</style>
